import React, { useState, useContext } from "react";
import {
  VALIDATOR_EMAIL,
  VALIDATOR_MINLENGTH,
  VALIDATOR_REQUIRE,
} from "../../shared/util/Validators";
import ContentBody from "../../shared/components/UIElements/ContentBody";
import Input from "../../shared/components/FormElements/Input";
import Form from "../../shared/components/FormElements/Form";
import { useForm } from "../../shared/hooks/FormHook";
import { AuthContext } from "../../shared/context/AuthContext";
import Loader from "../../shared/components/UIElements/Loader";
import Alert from "../../shared/components/UIElements/Alert";
import { useHttpClient } from "../../shared/hooks/httpHook";
import FileUpload from "../../shared/components/FormElements/FileUpload";

const Auth = () => {
  const auth = useContext(AuthContext);

  const [isLoginMode, setIsLoginMode] = useState(true);
  const { isLoading, error, sendRequest, errorHandler } = useHttpClient();

  const [formState, inputHandler, setFormData] = useForm(
    {
      email: {
        value: "",
        isValid: false,
      },
      password: {
        value: "",
        isValid: false,
      },
    },
    false
  );

  const authSubmitHandler = async (event) => {
    event.preventDefault();
    console.log(formState.inputs);
    if (isLoginMode) {
      try {
        const resData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "/users/login",
          "POST",
          JSON.stringify({
            email: formState.inputs.email.value,
            password: formState.inputs.password.value,
          }),
          { "Content-Type": "application/json" }
        );
        auth.login(resData.userId, resData.token);
      } catch (error) {}
    } else {
      try {
        const formData = new FormData();
        formData.append("name", formState.inputs.name.value);
        formData.append("email", formState.inputs.email.value);
        formData.append("password", formState.inputs.password.value);
        formData.append("image", formState.inputs.image.value);
        const resData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "/users/signup",
          "POST",
          formData
        );
        auth.login(resData.userId, resData.token);
      } catch (error) {}
    }
  };

  const switchModeHandler = () => {
    if (!isLoginMode) {
      setFormData(
        { ...formState.inputs, name: undefined, image: undefined },
        formState.inputs.email.isValid && formState.inputs.password.isValid
      );
    } else {
      setFormData(
        {
          ...formState.inputs,
          name: { value: "", isValid: false },
          image: { value: null, isValid: false },
        },
        false
      );
    }
    setIsLoginMode((prevMode) => !prevMode);
  };

  if (isLoading) {
    return <Loader />;
  }
  let errorWarning;
  if (error) {
    errorWarning = (
      <Alert
        title="Authentication Error"
        onClick={errorHandler}
        description={error}
      />
    );
  }

  return (
    <ContentBody>
      {errorWarning}
      <Form title="Log in" onSubmit={authSubmitHandler}>
        {!isLoginMode ? (
          <Input
            element="input"
            type="text"
            label="Username"
            placeholder="Enter username"
            id="name"
            name="name"
            errorText="Please enter a valid username"
            validators={[VALIDATOR_REQUIRE()]}
            onInput={inputHandler}
          />
        ) : null}
        <Input
          element="input"
          type="email"
          label="Email"
          placeholder="Enter email"
          id="email"
          name="email"
          errorText="Please enter a valid email address"
          validators={[VALIDATOR_EMAIL()]}
          onInput={inputHandler}
        />
        <Input
          element="input"
          type="password"
          label="Password"
          placeholder="Enter password"
          id="password"
          name="password"
          errorText="Please enter a valid password"
          validators={[VALIDATOR_MINLENGTH(6)]}
          onInput={inputHandler}
        />
        {!isLoginMode ? (
          <FileUpload
            label="Image"
            id="image"
            name="image"
            errorText="Please choose valid image"
            onInput={inputHandler}
          />
        ) : null}
        <div className="form-group row ">
          <label className="col-sm-2 col-form-label">&nbsp;</label>
          <div className="col-sm-10">
            <button
              type="submit"
              disabled={!formState.isValid}
              className="btn btn-primary mr-2"
            >
              {isLoginMode ? "Log in" : "Sign up"}
            </button>
            <button
              type="button"
              onClick={switchModeHandler}
              className="btn btn-success"
            >
              Switch to {!isLoginMode ? "Log in" : "Sign up"}
            </button>
          </div>
        </div>
      </Form>
    </ContentBody>
  );
};

export default Auth;
